module.exports = __webpack_public_path__ + "static/media/HCMM108.0bb7139b.jpg";